import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import './MetricCard.css';

const MetricCard = ({ title, value, icon, color, trend, trendValue, subtitle, link }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (link) {
      navigate(link);
    }
  };

  return (
    <Card
      className="metric-card"
      onClick={handleClick}
      sx={{
        background: `linear-gradient(135deg, ${color}15 0%, ${color}05 100%)`,
        border: `2px solid ${color}30`,
        borderRadius: '16px',
        transition: 'all 0.3s ease',
        cursor: link ? 'pointer' : 'default',
        '&:hover': {
          transform: link ? 'translateY(-8px)' : 'none',
          boxShadow: link ? `0 12px 24px ${color}30` : 'none',
        }
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="body2"
              sx={{
                color: '#666',
                fontWeight: 600,
                fontSize: '0.85rem',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                mb: 1
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="h3"
              sx={{
                color: color,
                fontWeight: 700,
                fontSize: '2.5rem',
                lineHeight: 1,
                mb: 0.5
              }}
            >
              {value}
            </Typography>
            {subtitle && (
              <Typography
                variant="caption"
                sx={{
                  color: '#888',
                  fontSize: '0.75rem'
                }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
          <Box
            sx={{
              backgroundColor: `${color}20`,
              borderRadius: '12px',
              padding: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {React.cloneElement(icon, {
              sx: { fontSize: 40, color: color }
            })}
          </Box>
        </Box>

        {trend !== undefined && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              mt: 2,
              pt: 1.5,
              borderTop: `1px solid ${color}20`
            }}
          >
            {trend === 'up' ? (
              <TrendingUpIcon sx={{ fontSize: 18, color: '#10B981', mr: 0.5 }} />
            ) : (
              <TrendingDownIcon sx={{ fontSize: 18, color: '#EF4444', mr: 0.5 }} />
            )}
            <Typography
              variant="body2"
              sx={{
                color: trend === 'up' ? '#10B981' : '#EF4444',
                fontWeight: 600,
                fontSize: '0.8rem'
              }}
            >
              {trendValue}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: '#888',
                ml: 0.5,
                fontSize: '0.8rem'
              }}
            >
              vs last period
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default MetricCard;
